import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock, User } from "lucide-react";
import Logo from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      toast.success("Connexion reussie");
      navigate("/admin/dashboard");
    } catch {
      toast.error("Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2D5016] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl" data-testid="admin-login-form">
        <div className="text-center mb-8">
          <Logo className="mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-bold text-[#2C2C2C]">Administration</h1>
          <p className="font-body text-sm text-[#6B6B6B] mt-1">Connectez-vous pour gerer le site</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block font-body text-sm text-[#2C2C2C] mb-1.5">Identifiant</label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B6B6B]" />
              <Input
                value={email} onChange={e => setEmail(e.target.value)}
                className="pl-10 rounded-lg border-[#DBCFB0] font-body" required
                data-testid="admin-email-input"
              />
            </div>
          </div>
          <div>
            <label className="block font-body text-sm text-[#2C2C2C] mb-1.5">Mot de passe</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B6B6B]" />
              <Input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                className="pl-10 rounded-lg border-[#DBCFB0] font-body" required
                data-testid="admin-password-input"
              />
            </div>
          </div>
          <Button
            type="submit" disabled={loading}
            className="w-full bg-[#2D5016] text-[#FDF8F0] rounded-full py-3 font-body font-medium hover:bg-[#2D5016]/90"
            data-testid="admin-login-btn"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
